/**
 *
 * @param basePath the base path of the route, i.e. /users
 * @param route the absolute path of the route, i.e. /users/:id
 * @returns the relative path with respect to the base route, i.e. /:id
 */

export const getPathRelativeToBasePath = ({
  basePath,
  route,
}: {
  basePath: string;
  route: string;
}) => {
  // for the case of unknown * route, we will return itself
  if (route === '*') {
    return route;
  }

  if (route.indexOf(basePath) === 0) {
    return route.replace(basePath, '');
  }

  // if the absolute path does not start with the base path, then this is a developer
  // error, as we assume that the absolute path always starts with the base path
  // we will throw error for this case
  throw new Error(
    `The basePath (${basePath}) does not match with the absolute path (${route})`
  );
};
